import { PageLoading } from '@/components/page-loading'
import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { ContentLayout } from '../content-layout'
import Resource from '@/pages/account-center/site-resource'
import Collect from '@/pages/account-center/site-collect'
import { t } from '@/i18n'

interface MenuItem {
  key: string
  label: string
  component: React.ReactNode
  show?: boolean
  name?: string
}

export const ResourceLayout = () => {
  const menuList: MenuItem[] = [
    {
      key: 'resource',
      label: t('Web应用列表'),
      component: <Resource />,
    },
    {
      key: 'collect',
      label: t('站点收集'),
      component: <Collect />,
    },
  ]

  return (
    <ContentLayout menuList={menuList}>
      <Suspense fallback={<PageLoading />}>
        <Outlet />
      </Suspense>
    </ContentLayout>
  )
}
